var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.34 255.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#329e51;}.cls-2{fill:#282828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255.34 5.4 255.34 217.52 219.15 255.07 219.15 255.08 5.66 255.08 5.66 5.4 255.34 5.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "70 0 70 5.4 5.66 5.4 5.66 66 0 66 0 0 70 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowCard);
export default __webpack_public_path__ + "static/media/window_card.6d052658283cb4b64a0a29afa521a3f5.svg";
export { ForwardRef as ReactComponent };